module.exports = __webpack_public_path__ + "static/animation-talk-person02-19b2cca56cf9de41f0c01d6ac133fe60.png";